import { h } from 'vue'
import {
  mdilCalendar,
  mdilCamera,
  mdilDelete,
  mdilDownload,
  mdilEye,
  mdilFile,
  mdilInformation,
  mdilLink,
  mdilLinkVariant,
  mdilMagnify,
  mdilNoteText,
  mdilPaperclip,
  mdilPencil,
  mdilPrinter,
} from '@mdi/light-js/mdil'
import SvgIcon from '@jamescoyle/vue-icon'

const iconComponentFabric = (path: string) => {
  return h(SvgIcon, {
    viewBox: '0 0 24 24',
    path: path,
    type: 'mdil',
  })
}

export const mdiLightIcons = {
  pencil: iconComponentFabric(mdilPencil),
  printer: iconComponentFabric(mdilPrinter),
  information: iconComponentFabric(mdilInformation),
  link: iconComponentFabric(mdilLink),
  'link-variant': iconComponentFabric(mdilLinkVariant),
  calendar: iconComponentFabric(mdilCalendar),
  'note-text': iconComponentFabric(mdilNoteText),
  file: iconComponentFabric(mdilFile),
  delete: iconComponentFabric(mdilDelete),
  download: iconComponentFabric(mdilDownload),
  eye: iconComponentFabric(mdilEye),
  magnify: iconComponentFabric(mdilMagnify),
  paperclip: iconComponentFabric(mdilPaperclip),
  camera: iconComponentFabric(mdilCamera),
}
